import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/index.css'
export default (app) => {
    app.use(ElementPlus)
}
